module.exports = __webpack_public_path__ + "media/site_templates/www.localcarpenters.net.au/images/feature_1-99f1a970b19cee97784b6857069afbf1.jpeg";